export default __webpack_public_path__ + "static/media/estrella-home-mobile.acf6e40d.svg";